import React from 'react';
import styled from 'styled-components';
import { useObserver } from 'mobx-react-lite';
import tagsStore from '../../../stores/tags.store';
import TagItem from './TagItem';
import serverStore from '../../../stores/server.store';
import { MONITOR_TYPES } from '../../../constants/monitor.types';
import uptimeStore from '../../../stores/uptime.store';
import mongodbStore from '../../../stores/mongodb.store';
import { addToast } from '../toasts/Toast';

const Styles = styled.div`
  //display: grid;
`;

const TagsList = ({
    serverTags,
    serverId,
    selectEvent,
    monitorType,
    showMessage = false,
    isServerCreated = false
}) => {
    return useObserver(
        () => (
            <Observed
                tags={ tagsStore.tags }
                serverTags={ serverTags }
                serverId={ serverId }
                monitorType={ monitorType }
                showMessage={ showMessage }
                selectEventOveride={ selectEvent }
                isServerCreated={ isServerCreated }
            />
        ));
};

const Observed = ({
    tags,
    serverId,
    selectEventOveride,
    showMessage,
    isServerCreated,
    monitorType,
    serverTags = []
}) => {
    const selectedTagIds = Array.isArray(serverTags) ? serverTags : [];

    const selectEvent = async (tagId, isToAdd) => {
        try {
            if (selectEventOveride) {
                await selectEventOveride(tagId, isToAdd);
                return;
            }
            if(monitorType === MONITOR_TYPES.SERVER){
                await serverStore.updateServerTags(serverId, tagId, isToAdd,
                    isServerCreated
                );
            }
            if(monitorType === MONITOR_TYPES.HEARTBEAT){
                await uptimeStore.updateUptimeTags(serverId, tagId, isToAdd);
            }
            if(monitorType === MONITOR_TYPES.MONGO){
                await mongodbStore.updateMongoTags(serverId, tagId, isToAdd);
            }
            addToast('Tags selection changed', 'suc');
        } catch (error) {
            addToast(error.message || 'Failed to change tags selection', 'error');
        }
    };

    const noTags = !tags || tags.length === 0;

    return (
        <Styles>
            { noTags && (
                <div>{ `No Tags${ showMessage
                    ? ', to add tags go to edit server'
                    : '' }` }</div>
            ) }
            { !noTags && tags.map((item, idx) => {
                const indexOf = selectedTagIds.indexOf(item._id);

                return (
                    <TagItem
                        selectEvent={ selectEvent }
                        selected={ indexOf > -1 }
                        key={ `${ item._id }_dzjjjawd-tag_${ idx }` }
                        tag={ item }
                    />);
            }) }
        </Styles>
    );
};

export default TagsList;
